import Vue from 'vue'
import {chartColors} from '@/helpers/color-helper'

const $ = kendo.jQuery
const ee = new Vue()

function createChart($container, options) {
  return new Promise(function(resolve, reject) {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: '/api/config/fxAlert/getChartDataSource',
          cache: false,
          type: 'GET',
          data: {fxAlertId: options.fxAlertId},
          dataType: 'json',
        },
      },
      schema: {
        parse: function(response) {
          chart.options.title.text = response.title
          return response
        },
        data: 'data',
        model: {
          fields: {
            evaluationDate: {type: 'date'},
            instrumentLabel: {type: 'string'},
            dateLabel: {type: 'string'},
            dataValue: {field: 'value', type: 'number'},
          },
        },
      },
      sort: {
        field: 'evaluationDate',
        dir: 'asc',
      },
      requestEnd: () => {
        chart.options.legend.visible = true
        chart.refresh()
      },
      error: err => reject(err),
    })

    const chart = $container
      .kendoChart({
        render: () => {
          resolve(chart)
          ee.$emit('render')
        },
        dataSource: dataSource,
        title: {
          padding: {
            bottom: 5,
          },
          font: 'bold 16px Arial',
          color: '#000',
        },
        seriesColors: chartColors(),
        series: [
          {
            field: 'dataValue',
            type: 'line',
            markers: {
              size: 3,
              visible: true,
            },
            labels: {
              visible: false,
            },
          },
        ],
        categoryAxis: {
          field: 'dateLabel',
          labels: {
            visible: true,
            rotation: -45,
            font: '10px Arial',
          },
          majorGridLines: {
            visible: false,
          },
        },
        pannable: {
          lock: 'y',
        },
        zoomable: {
          mousewheel: {
            lock: 'y',
          },
          selection: {
            lock: 'y',
          },
        },
        tooltip: {
          visible: true,
          template:
            "<div><b>Date:</b> #= dataItem.dateLabel #</div> <div><b>Value:</b> #=kendo.format('{0:N6}', value)#</div>",
        },
      })
      .data('kendoChart')
  })
}

function renderChart($container, options) {
  $container.empty()
  const $chartContainer = $('<div></div>').appendTo($container)
  return createChart($chartContainer, options)
}

export default {
  openChart: function(options) {
    const $window = $("<div class='fxRateChartWindow'></div>")
      .empty()
      .appendTo(document.body)
    var kendoWindow = $window
      .kendoWindow({
        visible: false,
        modal: true,
        width: '632px',
        height: '436px',
        resizable: false,
        actions: ['Close'],
        close: function() {
          this.destroy()
        },
      })
      .getKendoWindow()

    const $chart = $('<div></div>').appendTo($window.empty())
    kendoWindow.setOptions({
      title: 'Loading...',
    })
    kendoWindow.center().open()

    createChart($chart, options).then(function(fxRateChart) {
      kendoWindow.setOptions({
        title: 'FX Rates Chart',
      })
      fxRateChart.resize()
    })
  },
  render: function($container, options) {
    return renderChart($container, options).then(function(fxRateChart) {
      fxRateChart.resize()
    })
  },
  onRender: function(callback) {
    ee.$on('render', callback)
  },
}
